import React from 'react';
import { Card, CardBody, CardGroup, Col, Container, Row } from 'reactstrap';

export default (props) => {
    return (
        <div id="CommonPageHolder" 
        className="d-f-c">
            <Container>
                <Row className="justify-content-center">
                    <Col md="12">
                       
                            <Card className="p-4 text-center">
                                <CardBody>
                                    {props.children}
                                </CardBody>
                            </Card>
                        
                    </Col>
                </Row>
            </Container>
        </div>
    );
};
